var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 160V352C640 369.6 625.6 384 608 384H32C14.4 384 0 369.6 0 352V160C0 142.4 14.4 128 32 128H112V208C112 216.799 119.199 224 128 224S144 216.799 144 208V128H208V208C208 216.799 215.199 224 224 224S240 216.799 240 208V128H304V208C304 216.799 311.199 224 320 224S336 216.799 336 208V128H400V208C400 216.799 407.199 224 416 224S432 216.799 432 208V128H496V208C496 216.836 503.164 224 512 224C520.838 224 528 216.836 528 208V128H608C625.6 128 640 142.4 640 160Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerHorizontal);
export default __webpack_public_path__ + "static/media/ruler-horizontal.3e60ad77f812056b46d8a99665e640bd.svg";
export { ForwardRef as ReactComponent };